import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import { FormSelectField } from '../../../semantic-ui/components/form-select-field';

const AccreditationCompanyForm = ({
	orgTypes,
	isOrgTypesLoading,
	isTaxSystemsLoading,
	taxSystems,
	isTaxRatesLoading,
	taxRates,
	onTaxSystemChange,
}) => {
	return (
		<>
			<Grid className="accreditation-company-form">
				<Grid.Row className="accreditation-company-form__row accreditation-company-form__row-title">
					<div className="accreditation-company-form__second-title">Уставные документы</div>
				</Grid.Row>
				<Grid.Row className="accreditation-company-form__row">
					<Grid.Column width={5} className="accreditation-company-form__column">
						Тип организации
					</Grid.Column>
					<Grid.Column width={8} className="accreditation-company-form__column">
						<Field
							name="company.org_type_id"
							type="text"
							component={FormSelectField}
							autoComplete="off"
							options={orgTypes}
							search
							loading={isOrgTypesLoading}
							disabled={isOrgTypesLoading}
							noResultsMessage="Тип организации не найден"
							dropdownClassName="static"
							placeholder="Выберите тип организации"
						/>
					</Grid.Column>
				</Grid.Row>
				<Grid.Row className="accreditation-company-form__row">
					<Grid.Column width={5} className="accreditation-company-form__column">
						Система налогообложения
					</Grid.Column>
					<Grid.Column width={8} className="accreditation-company-form__column">
						<Field
							name="company.tax_system_id"
							type="text"
							component={FormSelectField}
							autoComplete="off"
							options={taxSystems}
							search
							icon="search"
							placeholder="Выберите систему налогообложения"
							loading={isTaxSystemsLoading}
							disabled={isTaxSystemsLoading}
							dropdownClassName="static"
							noResultsMessage="Система налогообложения не найдена"
							onChange={onTaxSystemChange}
						/>
					</Grid.Column>
				</Grid.Row>
				<Grid.Row className="accreditation-company-form__row">
					<Grid.Column width={5} className="accreditation-company-form__column">
						Налоговая ставка
					</Grid.Column>
					<Grid.Column width={8} className="accreditation-company-form__column">
						<Field
							name="company.tax_rate_id"
							type="text"
							component={FormSelectField}
							autoComplete="off"
							options={taxRates}
							search
							icon="search"
							dropdownClassName="static"
							placeholder="Выберите налоговую ставку"
							loading={isTaxRatesLoading}
							disabled={isTaxRatesLoading}
							noResultsMessage="Налоговая ставка не найдена"
						/>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		</>
	);
};

AccreditationCompanyForm.propTypes = {
	orgTypes: PropTypes.arrayOf(
		PropTypes.shape({
			text: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
			key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		}),
	),
	isOrgTypesLoading: PropTypes.bool,
	taxSystems: PropTypes.arrayOf(
		PropTypes.shape({
			text: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
			key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		}),
	),
	taxRates: PropTypes.arrayOf(
		PropTypes.shape({
			text: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
			key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		}),
	),
	isTaxSystemsLoading: PropTypes.bool,
	isTaxRatesLoading: PropTypes.bool,
	isSendingAccreditation: PropTypes.bool,
	onTaxSystemChange: PropTypes.func,
};

export { AccreditationCompanyForm };
